export const REQUESTED_SUBMIT_NOTIFICATION = 'REQUESTED_SUBMIT_NOTIFICATION';
export const requestedSubmitNotification = () => {
  return {
    type: REQUESTED_SUBMIT_NOTIFICATION
  };
};

export const RECEIVED_SUBMIT_NOTIFICATION = 'RECEIVED_SUBMIT_NOTIFICATION';
export const receivedSubmitNotification = response => {
  return {
    type: RECEIVED_SUBMIT_NOTIFICATION,
    response
  };
};

export const ERROR_SUBMIT_NOTIFICATION = 'ERROR_SUBMIT_NOTIFICATION';
export const errorSubmitNotification = () => {
  return {
    type: ERROR_SUBMIT_NOTIFICATION
  };
};